import React from "react";

const MatchCoachingIcon = (props: any) => {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M5.30366 16.1536H5.41738V16.0399V5.76395C5.41738 4.93202 6.09853 4.25088 6.93046 4.25088H8.92328H9.037V4.13716V3.5V3.38628H8.92328H6.93046C5.62045 3.38628 4.55279 4.45394 4.55279 5.76395V16.0399V16.1536H4.6665H5.30366Z"
        fill="currentColor"
        stroke="currentColor"
        stroke-width="0.227437"
        stroke-miterlimit="10"
      />
      <path
        d="M22.2358 18.4311H22.3496V18.4149C23.6071 18.3552 24.6135 17.3118 24.6135 16.0399V5.76395C24.6135 4.45394 23.5459 3.38628 22.2358 3.38628H12.814H12.7003V3.5V4.13716V4.25088H12.814H22.2358C23.0678 4.25088 23.7489 4.93202 23.7489 5.76395V16.0534C23.7489 16.8854 23.0678 17.5665 22.2358 17.5665H8.625H8.51128V17.6802V18.3174V18.4311H8.625H22.2358Z"
        fill="currentColor"
        stroke="currentColor"
        stroke-width="0.227437"
        stroke-miterlimit="10"
      />
      <path
        d="M24.3016 7.64844V7.53472H24.1879H4.9917H4.87798V7.64844V8.2856V8.39932H4.9917H24.1879H24.3016V8.2856V7.64844Z"
        fill="currentColor"
        stroke="currentColor"
        stroke-width="0.227437"
        stroke-miterlimit="10"
      />
      <path
        d="M14.8661 3.82422V3.7105H14.7524H14.1152H14.0015V3.82422V7.97254V8.08626H14.1152H14.7524H14.8661V7.97254V3.82422Z"
        fill="currentColor"
        stroke="currentColor"
        stroke-width="0.227437"
        stroke-miterlimit="10"
      />
      <path
        d="M18.4398 21.1968H18.5536V21.0831V17.9922V17.8785H18.4398H17.8027H17.689V17.9922V20.3187H11.1381V18.9412V18.8274H11.0244H10.3872H10.2735V18.9412V21.0831V21.1968H10.3872H18.4398Z"
        fill="currentColor"
        stroke="currentColor"
        stroke-width="0.227437"
        stroke-miterlimit="10"
      />
      <path
        d="M7.169 23.6989V23.8126H7.28271H22.0948H22.2086H22.2221V23.6989H22.3223V20.7571V20.6434H22.2086H21.5714H21.4577V20.7571V22.948H8.03359V22.411C8.03359 21.7418 8.57917 21.1962 9.24842 21.1962H10.699H10.8127V21.0825V20.4453V20.3316H10.699H9.24842C8.10109 20.3316 7.169 21.2637 7.169 22.411V23.6989Z"
        fill="currentColor"
        stroke="currentColor"
        stroke-width="0.227437"
        stroke-miterlimit="10"
      />
      <path
        d="M11.1872 14.0431H9.63533C9.64952 14.0265 9.66486 14.0099 9.68153 13.9932L9.68186 13.9936L9.68848 13.9856C9.75055 13.9111 9.92128 13.7397 10.2061 13.482C10.4937 13.2218 10.6882 13.014 10.8016 12.8722L10.8016 12.8722L10.8037 12.8694C10.9713 12.646 11.0845 12.4484 11.1698 12.2495L11.17 12.2496L11.1723 12.2429C11.2438 12.0428 11.2874 11.8265 11.2874 11.6082C11.2874 11.2112 11.1392 10.8694 10.8588 10.6038L10.8588 10.6038L10.8566 10.6018C10.5601 10.335 10.1784 10.2066 9.69601 10.2066C9.25442 10.2066 8.89039 10.3212 8.58324 10.5552C8.26486 10.7978 8.09372 11.1849 8.03754 11.6905L8.02494 11.8039L8.13838 11.8162L9.01956 11.911L9.13899 11.9239L9.1453 11.804C9.1582 11.5589 9.22215 11.4024 9.30194 11.3226C9.38425 11.2403 9.50168 11.1932 9.6689 11.1932C9.83612 11.1932 9.95356 11.2403 10.0359 11.3226C10.1174 11.4041 10.1652 11.521 10.1652 11.7031C10.1652 11.8492 10.1092 12.0039 9.9935 12.1839L9.99345 12.1838L9.99164 12.1868C9.95849 12.2421 9.88571 12.3287 9.76363 12.4541C9.64368 12.5774 9.48275 12.7317 9.27983 12.9211C8.77908 13.3813 8.42832 13.7573 8.25578 14.0587C8.08609 14.3418 7.97119 14.6561 7.94237 14.9875L7.93163 15.1111H8.05566H11.1601H11.2738V14.9973V14.2407L11.669 14.0431H11.1872Z"
        fill="currentColor"
        stroke="currentColor"
        stroke-width="0.227437"
        stroke-miterlimit="10"
      />
      <path
        d="M20.2107 10.7498L20.2107 10.7498L20.209 10.7476C19.9507 10.435 19.6039 10.2612 19.1776 10.2353V10.2183H19.0639C18.584 10.2183 18.2124 10.3951 17.9323 10.7341L17.9321 10.7343C17.5946 11.1453 17.4454 11.789 17.4454 12.6909C17.4454 13.5921 17.5944 14.2342 17.8892 14.6175L17.8892 14.6175L17.8905 14.6192C18.1836 14.9855 18.5825 15.177 19.0639 15.177C19.5437 15.177 19.9153 15.0003 20.1954 14.6612L20.1956 14.661C20.5333 14.2499 20.6824 13.5925 20.6824 12.7044C20.6824 11.816 20.5331 11.1602 20.2107 10.7498ZM18.6985 11.5842L18.6987 11.5843L18.7002 11.5777C18.7379 11.4144 18.797 11.3193 18.852 11.2735C18.9163 11.2198 18.9862 11.1914 19.0639 11.1914C19.1415 11.1914 19.2114 11.2198 19.2758 11.2735C19.3284 11.3173 19.3889 11.4228 19.442 11.6221C19.4919 11.8092 19.5195 12.1747 19.5195 12.718C19.5195 13.2613 19.4918 13.6255 19.4293 13.8382L19.4291 13.8382L19.4275 13.8447C19.3899 14.008 19.3307 14.1032 19.2758 14.149C19.2114 14.2026 19.1415 14.2311 19.0639 14.2311C18.9759 14.2311 18.9086 14.2097 18.852 14.1625C18.7994 14.1187 18.7389 14.0132 18.6857 13.8139C18.6358 13.6267 18.6082 13.2747 18.6082 12.718C18.6082 12.161 18.6359 11.7969 18.6985 11.5842Z"
        fill="currentColor"
        stroke="currentColor"
        stroke-width="0.227437"
        stroke-miterlimit="10"
      />
      <path
        d="M14.4815 12.2906C14.8887 12.2906 15.2188 11.9605 15.2188 11.5533C15.2188 11.1461 14.8887 10.816 14.4815 10.816C14.0743 10.816 13.7442 11.1461 13.7442 11.5533C13.7442 11.9605 14.0743 12.2906 14.4815 12.2906Z"
        fill="currentColor"
        stroke="currentColor"
        stroke-width="0.227437"
        stroke-miterlimit="10"
      />
      <path
        d="M14.4815 14.9742C14.8887 14.9742 15.2188 14.6441 15.2188 14.2369C15.2188 13.8297 14.8887 13.4996 14.4815 13.4996C14.0743 13.4996 13.7442 13.8297 13.7442 14.2369C13.7442 14.6441 14.0743 14.9742 14.4815 14.9742Z"
        fill="currentColor"
        stroke="currentColor"
        stroke-width="0.227437"
        stroke-miterlimit="10"
      />
    </svg>
  );
};

export default MatchCoachingIcon;
